export const UsersEndpoints = {
    list: () => '/users',
    create: () => '/users',
    update: (id: string) => `/users/${id}`,
    delete: (id: string) => `/users/${id}`,
    pin: (id: string) => `/users/${id}/pin`,
    password: (id: string) => `/users/${id}/password`,
};
